import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/lib/site";
import { Eyebrow, Reveal } from "./Reveal";

const Item = ({ faq, open, onToggle, index }) => (
  <div className="border-b border-black/10">
    <button
      data-testid={`faq-question-${index}`}
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-6 py-6 text-left group"
    >
      <span className="font-display text-lg sm:text-xl font-medium text-ink group-hover:text-brand transition-colors">
        {faq.q}
      </span>
      <span
        className={`shrink-0 grid place-items-center w-9 h-9 rounded-full border transition-all duration-300 ${
          open ? "bg-brand border-brand text-white rotate-45" : "border-black/15 text-ink"
        }`}
      >
        <Plus className="w-4 h-4" />
      </span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <p data-testid={`faq-answer-${index}`} className="pb-6 pr-12 text-slate-600 leading-relaxed">
            {faq.a}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Eyebrow>05 — FAQ</Eyebrow>
            <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl tracking-tight text-ink">
              Sawaal?
              <br />
              Jawab <em className="italic text-brand">hazir</em> hai.
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Aur koi sawaal hai? Seedha call kijiye — hum jaldi jawab denge.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-8">
          <div data-testid="faq-list" className="border-t border-black/10">
            {FAQS.map((faq, i) => (
              <Item
                key={faq.q}
                faq={faq}
                index={i}
                open={open === i}
                onToggle={() => setOpen(open === i ? -1 : i)}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
